import { Grid, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GridApi, RowClassParams, RowStyle } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { DelayByShift } from "../models/DelayByShift";
import { useTableData } from "./hooks";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";
import { reportTableStyles } from "../styles/reportTableStyles";

type Props = {
  isLoading: boolean;
  rows: DelayByShift[];
  setGridApi: (api: GridApi) => void;
};

export const DelaysReportTable = ({ isLoading, rows, setGridApi }: Props) => {
  const theme = useTheme();
  const styles = reportTableStyles(theme);

  const { columns } = useTableData();

  const getRowStyle = (
    params: RowClassParams<DelayByShift>,
  ): RowStyle | undefined => {
    if (params.data?.IsMicroDelay) {
      return { background: theme.palette.grey[200] };
    }
    return undefined;
  };

  return (
    <Grid onContextMenu={(e) => e.preventDefault()}>
      <Grid sx={styles.tableContainer}>
        <Grid container>
          <Grid item md={12} xs={12}>
            <Paper elevation={3} sx={styles.gridWrapper}>
              <AgGridReact
                loading={isLoading}
                rowData={rows}
                columnDefs={columns}
                defaultColDef={defaultColDef}
                getRowStyle={getRowStyle}
                getRowId={(params) => String(params.data.DelayId ?? 0)}
                onGridReady={(params) => setGridApi(params.api)}
                {...defaultGridOptions}
              />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
